<template>
  <b-card title="Semi Circle Chart Demo">
    <sag-semi-circle-chart :chart-data="chartData" />
  </b-card>
</template>

<script>
import SagSemiCircleChart from '@/components/basic/SagSemiCircleChart.vue'
import { BCard } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    SagSemiCircleChart
  },
  data() {
    return {
      chartData: {
        First: [
          { Label: "入庫達成率", Plan: "1000", Achieve: "590" }
        ],
        Second: [
          { Label: "良率_網印", Plan: "1000", Achieve: "890" }
        ],
        Third: [
          { Label: "良率_曝光", Plan: "1000", Achieve: "930" }
        ]
      }
    }
  }
}
</script>
